export var MessageType = /*#__PURE__*/function (MessageType) {
  MessageType["SUCCESS"] = "SUCCESS";
  MessageType["ERROR"] = "ERROR";
  MessageType["INFO"] = "INFO";
  MessageType["NONE"] = "NONE";
  return MessageType;
}({});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/dropin-payments/dist/esm/redux/message/message.types.js
// module id = 393
// module chunks = 11